import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';

import type { Coordinates, Parking } from 'src/features/parkingManagement/types/parking';
import type { GeneralAxiosError } from 'src/types/errors';

export type WorkTimeRecord = Record<number, { start_time: string | null; end_time: string | null }>;

export type UpdateParkingDTO = {
    parkingId?: string;
    description?: string;
    pricing_description?: string;
    number_of_floors?: number;
    number_of_spaces?: number;
    is_24_7?: boolean;
    working_time?: WorkTimeRecord | null;
    enable_online_payments?: boolean;
    serial_id?: string;
    point_of_interests?: string[];
    features?: string[];
    coordinates?: Coordinates | null;
    has_own_payment_provider?: boolean;
    subdomain?: string | null;
};

export const updateParking = ({ parkingId, ...data }: UpdateParkingDTO): Promise<Parking> => {
    return axios.patch(`/parkings/${parkingId}/`, data);
};

// TData -> Returns, TVariable -> Accepts as params
export const useUpdateParking = (
    options?: Omit<UseMutationOptions<Parking, GeneralAxiosError<Parking>, UpdateParkingDTO>, 'mutationFn'>,
) =>
    useMutation({
        mutationFn: updateParking,
        ...options,
    });
